module.exports = __webpack_public_path__ + "img/1970er-80er-Mayr0005.9674f860.jpg";